"use client";
import { Icon, ospThemes } from "@ospweb/sdk-ui";
import { FC } from "react";

interface TrackerReportItemLoadingProps {
  /** 已翻译好的 loading 文案，不包含省略号 */
  text: string;
}

export const TrackerReportItemLoading: FC<TrackerReportItemLoadingProps> = ({
  text,
}) => {
  return (
    <div className="rounded-3 py-5 px-4 bg-background_solid_neutral_tertiary flex flex-row items-center gap-3">
      <div className="rounded-full w-10 h-10 flex items-center justify-center shrink-0 relative">
        <div className="tracker-loading-ring-brand rounded-full" />
        <Icon
          name="portfolio_solid"
          size={24}
          color={ospThemes.colors.content_brand_primary}
        />
      </div>
      <div className="title_l text-content_primary">
        <span className="mr-0.5">{text}</span>
        <span className="loading-ellipsis" aria-hidden="true" />
      </div>
    </div>
  );
};
